videojs.addLanguage('ru', {
	"Play": "Воспроизвести",
	"Pause": "Приостановить",
	"Current Time": "Текущее время",
	"Duration Time": "Продолжительность",
	"Remaining Time": "Оставшееся время",
	"Stream Type": "Тип потока",
	"LIVE": "ОНЛАЙН",
	"Loaded": "Загрузка",
	"Progress": "Прогресс",
	"Fullscreen": "Полноэкранный режим",
	"Non-Fullscreen": "Неполноэкранный режим",
	"Mute": "Без звука",
	"Volume": "Громкость",
	"Unmute": "Со звуком",
	"Playback Rate": "Скорость воспроизведения",
	"Subtitles": "Субтитры",
	"subtitles off": "Субтитры выкл.",
	"Audio Track": "Аудиодорожки",
	"Captions": "Подписи",
	"captions off": "Подписи выкл.",
	"Chapters": "Главы",
	"You aborted the media playback": "Вы прервали воспроизведение видео",
	"A network error caused the media download to fail part-way.": "Ошибка сети вызвала сбой во время загрузки видео.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "Невозможно загрузить видео из-за сетевого или серверного сбоя либо формат не поддерживается. Воспользуйтесь другим браузером или попробуйте позже.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Воспроизведение видео было приостановлено из-за повреждения либо в связи с тем, что видео использует функции, неподдерживаемые вашим браузером.",
	"No compatible source was found for this media.": "Совместимые источники для этого видео отсутствуют.",
	"No compatible source was found for this DASH media.": function() {
		var ua = navigator.userAgent,
			is_desktop = !/(iPhone|iPod|iPad|Android|BlackBerry|IEMobile|GoogleTV|Smart-?TV|AppleTV|Mobile|Kindle|Dolfin|Dolphin)/i.test(ua),
			text = 'DRM error';

		var link = document.createElement('a');
		link.href = "//google.ru/chrome/";
		link.target = "_blank";
		link.textContent = "Chrome";
		link.setAttribute('class', 'vjs-error-display-link');

		var chrome_btn = document.createElement('a');
		chrome_btn.href = "//google.ru/chrome/";
		chrome_btn.target = "_blank";
		chrome_btn.setAttribute('class', 'vjs-error-display-browser-btn');
		var chrome_icon = document.createElement('span');
		chrome_icon.setAttribute('class', 'vjs-error-display-bb-chrome');
		var chrome_txt = document.createElement('span');
		chrome_txt.textContent = " Скачать Chrome";
		chrome_btn.appendChild(chrome_icon);
		chrome_btn.appendChild(chrome_txt);

		if (is_desktop || /Android (?![1-3])/i.test(ua)) {// >= 4.0
			text = [document.createTextNode("Извините, к сожалению, ваш браузер не поддерживается."), document.createElement("br"), document.createTextNode("Воспользуйтесь браузером "), link, document.createTextNode("."), document.createElement("br"), chrome_btn];
		} else {
			var face_icon = document.createElement('span');
			face_icon.setAttribute('class', 'vjs-error-display-face-icon');

			text = [face_icon, document.createElement("br"), document.createTextNode("Извините, к сожалению, просмотр возможен только на ОС Android версии 4.0 и выше, персональном компьютере или Mac.")];
		} 
		return text;
	},
	"Play Video": "Воспроизвести видео",
	"Close": "Закрыть",
	"Modal Window": "Модальное окно",
	"This is a modal window": "Это модальное окно.",
	"This modal can be closed by pressing the Escape key or activating the close button.": "Модальное окно можно закрыть нажав Esc или кнопку закрытия окна.",
	", opens captions settings dialog": ", откроется диалог настройки подписей",
	", opens subtitles settings dialog": ", откроется диалог настройки субтитров",
	", opens descriptions settings dialog": ", откроется диалог настройки описаний",
	", selected": "выбрано",
	/* suggested video */
	"You may also like": "Вам также может понравиться",
	"Viewers": function(viewersCount) {
		var mod10 = viewersCount % 10,
			mod100 = viewersCount % 100;
		if (mod100 >= 11 && mod100 <= 14) return "зрителей";
		if (mod10 == 1) return "зритель";
		if (mod10 >= 2 && mod10 <= 4) return "зрителя";
		if (mod10 == 0 || mod10 >= 5 && mod10 <= 9) return "зрителей";
	}
});